import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import useUpdateRouteQueryWithReplace from "./useUpdateRouteQueryWithReplace";

const useTable = (props) => {
  const {
    // data,
    pageSize = 10,
    defaultOrderBy = "",
    defaultOrder = "desc",
    defaultPage = 1,
    defaultRowsPerPage = pageSize,
    defaultSelected = [],
    onSort,
    onSelectRow,
    onChangePage,
    onChangeRowsPerPage,
    onChangeDense,
  } = props;

  const location = useLocation();
  const [searchParams] = useSearchParams();

  // const updateRouteQuery = useUpdateRouteQuery();
  const updateRouteQueryWithReplace = useUpdateRouteQueryWithReplace();
  const queryRowPerPage = searchParams.get("rowsPerPage");

  const [orderBy, setOrderBy] = useState(defaultOrderBy);
  const [order, setOrder] = useState(defaultOrder);
  const [page, setPage] = useState(defaultPage);
  const [rowsPerPage, setRowsPerPage] = useState(
    queryRowPerPage && !Number.isNaN(+queryRowPerPage)
      ? +queryRowPerPage
      : defaultRowsPerPage
  );
  const [selected, setSelected] = useState(defaultSelected);
  const [dense, setDense] = useState(false);

  useEffect(() => {
    if (defaultOrderBy && !searchParams.get("orderBy")) {
      updateRouteQueryWithReplace({
        query: {
          orderBy: defaultOrderBy,
          order,
        },
        pathName: location.pathname,
      });
    }
  }, [
    location.search,
    location.pathname,
    defaultOrderBy,
    order,
    searchParams,
    updateRouteQueryWithReplace,
  ]);

  useEffect(() => {
    if (
      location &&
      location.pathname + location.search &&
      location.search !== location.pathname
    ) {
      const queryPage = searchParams.get("page");
      setPage(queryPage && !Number.isNaN(+queryPage) ? +queryPage : 1);

      const queryRowPerPage = searchParams.get("rowsPerPage");

      setRowsPerPage(
        queryRowPerPage && !Number.isNaN(+queryRowPerPage)
          ? +queryRowPerPage
          : defaultRowsPerPage
      );

      const orderByValue = searchParams.get("orderBy");

      if (orderByValue) {
        setOrderBy(typeof orderByValue === "string" ? orderByValue : "");
      }

      const queryOrder = searchParams.get("order");
      const orderValue =
        queryOrder === "asc" || queryOrder === "desc"
          ? searchParams.get("order")
          : "desc";
      if (orderValue !== null) {
        setOrder(orderValue);
      }
    }
  }, [location, defaultRowsPerPage, searchParams]);

  const handleSort = (_orderBy, _order) => {
    setOrderBy(_orderBy);
    updateRouteQueryWithReplace({
      query: { orderBy: _orderBy, order: _order },
      pathName: location.pathname,
    });
    if (onSort) {
      onSort(_orderBy, _order);
    }
  };

  const handleOrder = (_order) => {
    setOrder(_order);
  };

  const handleSelectRow = (_selectedId) => {
    const selectedIndex = selected.indexOf(_selectedId);

    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, _selectedId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (onSelectRow) {
      onSelectRow(newSelected);
    }
  };

  const handleSelectAllRow = (selectAll, _selectedIds) => {
    if (selectAll) {
      // Select all rows
      setSelected(_selectedIds);
    } else {
      // Deselect all rows
      setSelected([]);
    }
  };

  const handleChangePage = (_page) => {
    setPage(_page);
    if (onChangePage) {
      onChangePage(_page);
    }
  };

  const handleChangeRowsPerPage = (_rowsPerPage) => {
    handleChangePage(1);
    setRowsPerPage(_rowsPerPage);
    if (onChangeRowsPerPage) {
      onChangeRowsPerPage(_rowsPerPage);
    }
  };

  const handleChangeDense = (_dense) => {
    setDense(_dense);
    if (onChangeDense) {
      onChangeDense(_dense);
    }
  };

  return {
    orderBy,
    order,
    page,
    rowsPerPage,
    selected,
    dense,
    handleSort,
    handleOrder,
    handleSelectRow,
    handleSelectAllRow,
    handleChangePage,
    handleChangeRowsPerPage,
    handleChangeDense,
  };
};

export default useTable;

export function emptyRows(page, rowsPerPage, arrayLength) {
  return page > 1 ? Math.max(0, page * rowsPerPage - arrayLength) : 0;
}
